import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { FlowsState } from './state';
import { defaultParams } from './initialParams';


const defaultState: FlowsState = {
  flows: [],
  landingElements: [],
  canAddElements: false,
};

export const flowsModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
